import { useState } from "react";
import ContactForm from "../components/Pages/Contact/ContactForm";
import ContactSuccess from "../components/Pages/ContactSuccess";
import { useAppContext } from "../_context";
import { isPossiblePhoneNumber, parsePhoneNumber } from "libphonenumber-js";
import { apiUrl, query } from "../utilities/Helpers";
import { validateEmail } from "../utilities/validations";
import Head from "next/head";

const Contact = ({ reason }) => {
  const [{ tx, locale }] = useAppContext();
  const [errors, setErrors] = useState({});
  const [messageSent, setMessageSent] = useState(false);

  const sendNotification = async (payload) => {
    const result = await fetch(apiUrl("/api/v1/web/contactUsRequest"), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-api-version": "New",
      },
      body: JSON.stringify(payload),
    });
    return result;
  };

  const getPhoneNumber = () => {
    const raw = document.getElementById("contact-phone").value;
    try {
      const phoneNumber = parsePhoneNumber(raw, locale === "en" ? "GB" : "CZ");
      return phoneNumber.format("E.164");
    } catch (e) {
      return null;
    }
  };

  const validate = (payload) => {
    const newErrors = [];
    let firstError = null;

    if (!payload.fullName) {
      newErrors["contact-full-name"] = null;
      firstError = "contact-full-name";
    }

    if (!validateEmail(payload.email)) {
      newErrors["contact-email"] = tx["Please enter a valid email address"];
      firstError = firstError || "contact-email";
    }

    if (!payload.text) {
      newErrors["contact-message"] = null;
      firstError = firstError || "contact-message";
    }

    if (!payload.reason) {
      newErrors["contact-reason"] = null;
      firstError = firstError || "contact-reason";
    }

    if (!payload.phoneNumber) {
      newErrors["contact-phone"] = tx["Please enter a valid phone number"];
      firstError = firstError || "contact-phone";
    }

    try {
      if (!isPossiblePhoneNumber(payload.phoneNumber)) {
        newErrors["contact-phone"] = tx["Please enter a valid phone number"];
        firstError = firstError || "contact-phone";
      }
    } catch (e) {
      console.log(e);
      newErrors["contact-phone"] = tx["Please enter a valid phone number"];
      firstError = firstError || "contact-phone";
    }

    if (firstError) {
      query(`#${firstError}`)?.focus();
      setErrors(newErrors);
      return false;
    }

    return true;
  };

  const handleServerValidationErrors = (errors) => {
    const map = {
      fullName: "contact-full-name",
      phoneNumber: "contact-phone",
      email: "contact-email",
      text: "contact-message",
      reason: "contact-reason",
    };
    let firstError = null;
    const output = {};

    errors.forEach((e) => {
      const serverId = e.field[0];
      const htmlId = map[serverId];

      if (!firstError) {
        firstError = htmlId;
      }

      output[htmlId] = null;
    });

    query(`#${firstError}`).focus(); // @todo fix
    setErrors(output);
  };

  const clickHandler = async (e) => {
    e.preventDefault();
    const payload = {
      fullName: document.getElementById("contact-full-name").value,
      phoneNumber: getPhoneNumber(),
      email: document.getElementById("contact-email").value,
      text: document.getElementById("contact-message").value,
      reason: document.getElementById("contact-reason").value,
    };

    if (!validate(payload)) {
      return;
    }

    const result = await sendNotification(payload);

    if (result.ok) {
      setMessageSent(true);
      document.body.scrollTop = document.documentElement.scrollTop = 0;
    } else {
      if (result.message === "validation error") {
        handleServerValidationErrors();
      }
    }
  };

  return (
    <>
      <Head>
        <title>RacketPal - {tx["Contact"]}</title>
      </Head>
      {messageSent ? (
        <ContactSuccess />
      ) : (
        <ContactForm
          onClick={clickHandler}
          allErrors={errors}
          defaultReason={reason}
        />
      )}
    </>
  );
};

export const getServerSideProps = async (context) => {
  return {
    props: {
      reason: context?.query?.reason || null,
    },
  };
};

export default Contact;
